import { useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import { SystemBanner } from "@components/shared/elements/system-banner";
import { SYSTEM_BANNER_HEIGHT_VAR } from "@utils/shared/system-banner";
import { COMPONENTS } from "@theme/admin";

// The system banner above the admin top nav, beside the side nav like the top nav itself.
// Pages that fill the viewport size themselves as 100vh minus the top nav, so the slot
// publishes its own height (0px without a banner) for them to subtract as well.
export const SystemBannerSlot = () => {
  const ref = useRef(null);

  useEffect(() => {
    const slot = ref.current;
    const root = document.documentElement;
    const publish = () => root.style.setProperty(SYSTEM_BANNER_HEIGHT_VAR, `${slot.offsetHeight}px`);
    // On the next frame: resizing the page from inside the observer's callback makes the browser
    // raise a "ResizeObserver loop" error.
    let raf;
    const observer = new ResizeObserver(() => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(publish);
    });
    observer.observe(slot);
    publish();
    return () => {
      cancelAnimationFrame(raf);
      observer.disconnect();
      root.style.removeProperty(SYSTEM_BANNER_HEIGHT_VAR);
    };
  }, []);

  return (
    <Box ref={ref} sx={{ ml: { lg: `${COMPONENTS.SIDE_NAV_WIDTH}px` } }}>
      <SystemBanner />
    </Box>
  );
};
